import { Component, Inject } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IIkSelectPaymentPaiementProfile, IIkSelectPaymentChangeMethodEditModalData } from '@app/invitation/invitation-b2b/invitation-b2b-client/invitation-b2b-client.interfaces';
import { IkSelectPaymentChangeBillingAddressEditModalComponent } from '../change-biilling-address-edit-modal/ik-select-payment-change-biilling-address-edit-modal.component';

@Component({
  selector: 'app-ik-select-payment-change-profile-edit-modal',
  templateUrl: './ik-select-payment-change-profile-edit-modal.component.html',
  styleUrls: ['./ik-select-payment-change-profile-edit-modal.component.scss'],
})
export class IkSelectPaymentChangeProfileEditModalComponent {
  loading = false;
  selectedProfile: IIkSelectPaymentPaiementProfile;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: IIkSelectPaymentChangeMethodEditModalData,
    public dialogRef: MatDialogRef<IkSelectPaymentChangeBillingAddressEditModalComponent>,
  ) {
    this.selectedProfile = data.paiementProfiles.find(profil => profil.default === true);
  }

  save(): void {
    this.dialogRef.close();
  }

  onSelectProfile(
    event: MatCheckboxChange,
    profile: IIkSelectPaymentPaiementProfile,
  ): void {
    if (event.checked) {
      this.selectedProfile = profile;
    }
  }

  close(): void {
    this.dialogRef.close();
  }
}
